import CONSTANTS from '../../utils/constants';
import { AdfApplication, CodatCompany } from './adf-app-types'

// TODO this got moved to common-utils, but it's too cumbersome to switch all references
// from this to common-utils, so we should update those components using this version to the
// common-utils version as we find them relevant to our tickets.

export function formatPhoneNumber(phone: string = ''): string {
   phone = phone?.replace(/\D/g, '') ?? '';

  if (phone.length === 7) {
    return phone.replace(/(\d{3})(\d{4})/, "$1-$2");
  } 
  
  if (phone.length === 10) {
    return phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
  } 
  
  if (phone.length === 11 || phone.length === 12) {
    return phone.replace(/(\d{1,2})(\d{3})(\d{3})(\d{4})/, "+$1 ($2) $3-$4");
  }

  return phone;
}

// TODO: This should actually be closer to the data-grid stuff, but let's move it later...
export function makeAdfRows(adfs: AdfApplication[], codatCompanies: CodatCompany[]): any[] {
    return adfs.map((adf) => {
        const matchingCodatComp = codatCompanies?.find((codatComp) => codatComp.id === adf.codatCompanyId)
        return { ...adf, codatConnectionStatus: matchingCodatComp?.dataConnections?.[0]?.status ?? '' };
    });
}

export function isNotEditable(adf: AdfApplication): boolean {
    const notEditable = true
    const editable = false
    
    if (!adf) return notEditable;
    
    const source = adf?.creditSolutionsContactSource.toLowerCase()
    
    if (source.includes('crm') && hasCsInfo(adf?.creditSolutionsContact, adf?.creditSolutionsContactEmail))
        return notEditable;
    
    return editable;
}

function hasCsInfo(contact: string, email: string): boolean {
    return (!isEmpty(contact) && !isEmpty(email));
}

function isEmpty(str): boolean {
    return !str || str.length === 0;
}

export function isInvalidCif(cif: string): boolean {
    const valid = false
    const invalid = true

    if (cif === null || cif === undefined)
        return invalid;

    // Invalid if not length 0 and not length 9 or uses non-numerics
    if ((cif.length !== 0 && cif.length !== 9) || !/^\d*$/.test(cif))
        return invalid;

    return valid;
}


export function isInvalidCrmId(crmId: string): boolean {
    return !/^(\d{0,10})$/.test(crmId ?? "");
}

export function isInvalidEmail(e: string): boolean {
    const invalid = true
    const valid = false

    if (e === undefined || e === null || e === '') return valid

    const matches = e.match(CONSTANTS.EMAIL_REGEX)

    if (!matches) return invalid

    return valid;
}

export function showCsEmailHelperText(email: string) {
    return isInvalidEmail(email) ? 'Please enter a valid email' : ''
}

export function showCifHelperText(cif: string) {
    return isInvalidCif(cif) ? 'CIF must be 9 digits' : ''
}

export function showCrmHelperText(crm: string) {
    return isInvalidCrmId(crm) ? 'CRM entity ID must be 10 characters or fewer' : ''
}

export function replaceNoneWithNull(val: string): string {
    return val === 'None' ? null : val
}